@if (clientUuids && clientUuids.length > 0) {
	<nz-table
		#courseTable
		[nzData]="courses()"
		[nzBordered]="true"
		[nzShowPagination]="false"
		[nzFrontPagination]="false"
		nzSize="middle"
	>
		<thead>
			<tr>
				<th nzWidth="40%" [nzSortFn]="sortNameFn" [nzSortOrder]="sortOrder()">Client</th>
				<th
					nzWidth="40%"
					[nzSortFn]="sortNameFn"
					[nzSortOrder]="sortOrder()"
					(nzSortOrderChange)="onSortOrderChange($event)"
				>
					Course
				</th>
				<th nzWidth="20%">Product</th>
				<th nzWidth="20%">Active</th>
			</tr>
		</thead>
		<tbody>
			@for (course of courseTable.data; track course) {
				<tr
					(click)="selectCourse(course)"
					[class.selected]="selectedCourse()?.uuid === course.uuid"
					class="course-row"
				>
					<td>{{ course.client_uuid }}</td>
					<td>{{ course.active_text?.name }}</td>
					<td>{{ course.product_name }}</td>
					<td>{{ course.active ? 'Active' : 'Inactive' }}</td>
				</tr>
			}
		</tbody>
	</nz-table>
} @else {
	<nz-empty nzNotFoundContent="No client selected" [nzNotFoundImage]="'simple'"></nz-empty>
}
